import { EntityConfig } from '../hooks/useEntity';

export interface ResourceType {
  id: string;
  serviceName: string;
  appName: string;
  cost: number;
  billingCycle: 'monthly' | 'yearly' | 'one-time';
  startDate: string;
  renewalDate: string;
  status: 'active' | 'inactive' | 'trial';
  notes?: string;
  created_at?: string;
  updated_at?: string;
}

export const resourceEntityConfig: EntityConfig<ResourceType> = {
  entityType: 'Resource',
  properties: {
    serviceName: { type: 'string', required: true },
    appName: { type: 'string', required: true },
    cost: { type: 'number', required: true },
    billingCycle: { type: 'string', required: true },
    startDate: { type: 'string', required: true },
    renewalDate: { type: 'string', required: true },
    status: { type: 'string', required: true },
    notes: { type: 'string', required: false },
  },
  requiredFields: ['serviceName', 'appName', 'cost', 'billingCycle', 'startDate', 'renewalDate', 'status'],
  orderBy: 'renewalDate',
};
